export default __webpack_public_path__ + "static/media/headerLogo.a8cd16ce.jpeg";